import { FC, PropsWithChildren, ReactNode } from "react";
import cn from "classnames";

import {ReactComponent as Tabs} from '../../images/tabs.svg'
import styles from './index.module.scss'

type ScreenLayoutProps = {
  className?: string;
  header?: ReactNode;
  hiddenTabs?: boolean;
}

export const ScreenLayout: FC<PropsWithChildren<ScreenLayoutProps>> = ({ children, hiddenTabs, header, className }) => {
  return(
    <div className={styles.wrapper}>
      <div className={styles.header}>
        {header}
      </div>
      <div className={cn(styles.content, className)}>
        {children}
      </div>
      <div className={styles.footer}>
        <Tabs className={cn({[styles.hidden]: hiddenTabs})} />
      </div>
    </div>
  )
}